<div class="mb-10">
  <a [routerLink]="routerLink"><small>{{ text | translate }}</small></a>
</div>
